<template>
  <main class="instant-points">
    <div class="offer offer-name">
      <div class="offer-label">points to be issued instantly</div>
      <div class="offer-value">{{ payload.bonus_value }} {{ payload.bonus_value | pluralize('point', 'points') }}</div>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    payload: Object
  },

  name: "instant-points-preview"
}
</script>

<style scoped>
.instant-points {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}

.instant-points .offer{
  overflow: hidden;
  padding: 0 6px;
}

.instant-points .offer-label {
  color: gray;
  font-size: 1em;
}

.instant-points .offer-value {
  font-size: 1.5em;
}
</style>
